<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b" id="contents"><a id="page_v"><span class="small">CONTENTS</span></a></h2><a id="page_v">
</a><p class="center"><a id="page_v"></a><a class="nounder" href="#/xhtml/for#for"><em>Series Editor’s Foreword</em></a></p>
<p class="center"><a class="nounder" href="#/xhtml/ack#ack"><em>Acknowledgments</em></a></p>
<p class="centert"><a class="nounder" href="#/xhtml/intro#intro"><span class="small">INTRODUCTION</span></a></p>
<p class="center"><a class="nounder" href="#/xhtml/intro#intro">Consumer Revolutions</a></p>
<p class="centert"><a class="nounder" href="#/xhtml/ch1#ch1">1</a></p>
<p class="center"><a class="nounder" href="#/xhtml/ch1#ch1">The English Commercial Empire Expands</a></p>
<p class="centert"><span class="nounder" href="#/xhtml/ch2#ch2" title="Link target outside of Sample">2</span></p>
<p class="center"><span class="nounder" href="#/xhtml/ch2#ch2" title="Link target outside of Sample">The Rise of a “Tea-fac’d Generation”</span></p>
<p class="centert"><span class="nounder" href="#/xhtml/ch3#ch3" title="Link target outside of Sample">3</span></p>
<p class="center"><span class="nounder" href="#/xhtml/ch3#ch3" title="Link target outside of Sample">Politicizing American Consumption</span></p>
<p class="centert"><span class="nounder" href="#/xhtml/ch4#ch4" title="Link target outside of Sample">4</span></p>
<p class="center"><span class="nounder" href="#/xhtml/ch4#ch4" title="Link target outside of Sample">The Global Dimensions of the American Tea Crisis</span></p>
<p class="centert"><span class="nounder" href="#/xhtml/ch5#ch5" title="Link target outside of Sample">5</span></p>
<p class="center"><span class="nounder" href="#/xhtml/ch5#ch5" title="Link target outside of Sample">Repatriating Tea in Revolutionary America</span></p>
<p class="centert"><span class="nounder" href="#/xhtml/ch6#ch6" title="Link target outside of Sample">6</span></p>
<p class="center"><span class="nounder" href="#/xhtml/ch6#ch6" title="Link target outside of Sample">Chinese Tea and American Commercial Independence</span></p>
<p class="centert"><span class="nounder" href="#/xhtml/conclu#conclu" title="Link target outside of Sample"><span class="small">CONCLUSION</span></span></p>
<p class="center"><span class="nounder" href="#/xhtml/conclu#conclu" title="Link target outside of Sample">Consumer Desires</span></p>
<p class="centert"><span class="nounder" href="#/xhtml/notes#notes" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="center"><span class="nounder" href="#/xhtml/source#source" title="Link target outside of Sample"><em>Essay on Sources</em></span></p>
<p class="center"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample"><em>Index</em></span><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0fb11946